export default __webpack_public_path__ + "static/media/bg-login.bb7a3340.png";